import { countries } from ".";

export const getCountryCodeFromCountry = (code) => {
  const country = countries.find((c) => c.code === code);
  return country && country.countryCode;
};
